import React, { useEffect, useState } from 'react'

//MUI IMPORTS
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Stack,
    Chip,
    Paper,
} from "@mui/material";

import {
    Business as BusinessIcon,
    CalendarMonth as CalendarIcon,
    Description as FileIcon,
    Download as DownloadIcon,
    CheckCircle as CheckIcon,
} from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import moment from 'moment';

//CUSTOM IMPORTS
import Navbar from '../../Navbar'
import { getData } from '../../../services/library';
import { UrlApi } from '../../../services/apirest';
import Notify from '../../Notify';
// import armarNombreDJIB from './helpers';
import CustomBackdrop from "../../CustomBackdrop"

export default function ArchivoPercIva() {
    const [empresas, setEmpresas] = useState();
    const [periodos, setPeriodos] = useState();
    const anios = [moment().year()]
    const mesActual = moment().month() + 1
    const [ddjjParams, setDdjjParams] = useState({
        idEmpresa: null,
        mes: mesActual,
        anio: anios[0],
        idImpuesto: null
    });
    const [notify, setNotify] = useState(null);
    const [generando, setGenerando] = useState(false);
    const [alertProps, setAlertProps] = useState();
    const [userRes, setUserRes] = useState();
    const [showForm, setShowForm] = useState(true);

    useEffect(() => {
        // getData(`/empresas/facturadoras`, setEmpresas)
        getData(`/empresas/agrupadas/facturadoras`, setEmpresas)
        // getData(`/impuestos/iibb`, setIibbs)
        getData(`/meses`, setPeriodos)
    }, [])

    const handleLimpiar = () => {
        setDdjjParams({
            idEmpresa: null,
            mes: null,
            anio: anios[0],
        })
    }

    const handleGenerar = async () => {
        const fileName = "percepcionesIva.txt";

        try {
            setGenerando(true);
            const periodo = `${ddjjParams.mes}-${ddjjParams.anio}`;
            const cuit = empresas.find(empresa=>empresa.idempresa == ddjjParams.idEmpresa).cuit;

            // const ruta = `${UrlApi}/archivos_salida/ddjj_perciva/${ddjjParams.idEmpresa}/${periodo}`;
            const ruta = `${UrlApi}/archivos_salida/ddjj_perciva/${cuit}/${periodo}`;

            const response = await fetch(ruta, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    nombreArchivo: `${fileName}`,
                }),
            });

            // Controlamos si el servidor respondió con un error (ej: status 400 o 500)
            if (!response.ok) {
                throw new Error("Error en el servidor al generar el archivo");
            }

            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
                const dataJson = await response.json();

                if (dataJson.sinDatos) {
                    setNotify({
                        open: true,
                        message: dataJson.message || "No hay datos para este período.",
                        duracion: 4000,
                        severity: "info"
                    });
                    setGenerando(false);
                    return;
                }
            }

            const headerAlertas = response.headers.get('X-Alertas-Proceso');
            let textoAlertas = "";

            const headerInfo = response.headers.get('X-Info-Proceso');

            if (headerAlertas || headerInfo) {
                const alertas = headerAlertas ? JSON.parse(decodeURIComponent(headerAlertas)) : [];
                const info = headerInfo ? JSON.parse(decodeURIComponent(headerInfo)) : null;

                if (!!info) {
                    setShowForm(false)
                    setUserRes(info)
                }

                if (alertas && alertas.length > 0) {
                    textoAlertas = "\n\nAdvertencias:\n• " + alertas.join("\n- ");
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${fileName}.zip`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            setNotify({
                open: true,
                message: `Archivo generado y descargado.${textoAlertas}`,
                duracion: textoAlertas ? 5000 : 1500,
                severity: textoAlertas ? "warning" : "success"
            });

            setGenerando(false);

        } catch (error) {
            setNotify({
                open: true,
                message: error.message,
                severity: "error"
            });
            setGenerando(false);
        }
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#1565c0",
            },
            secondary: {
                main: "#43a047",
            },
            background: {
                default: "#f5f7fa",
            },
        },
        typography: {
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        },
        components: {
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 16,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        textTransform: "none",
                        fontWeight: 600,
                    },
                },
            },
        },
    });

    return (
        <div>
            <div>
                <Navbar />
                <ThemeProvider theme={theme}>
                    <Box
                        sx={{
                            minHeight: "90vh",
                            bgcolor: "background.default",
                            p: 2
                        }}
                    >
                        <Box maxWidth={700} mx="auto">
                            {
                                showForm && (
                                    <>
                                        <Box textAlign="center" mb={2}>
                                            <Typography
                                                variant="h4"
                                                component="h1"
                                                fontWeight={700}
                                                color="primary.main"
                                                gutterBottom
                                            >
                                                Generador DDJJ Percepciones Iva
                                            </Typography>
                                            <Typography variant="body1" color="text.secondary">
                                                Genere los archivos con las declaraciones juradas de percepciones de iva para su presentación.
                                            </Typography>
                                        </Box>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                py: 1,
                                                px: 2,
                                                mb: 3,
                                                bgcolor: "#e3f2fd",
                                                borderRadius: 2,
                                                border: "1px solid #90caf9",
                                            }}
                                        >
                                            <Typography variant="subtitle2" color="primary.dark" gutterBottom>
                                                Archivos que se generarán:
                                            </Typography>

                                            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                                <Chip
                                                    icon={<FileIcon />}
                                                    label="Retenidos/percibidos"
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                />
                                                <Chip
                                                    icon={<FileIcon />}
                                                    label="Sicore"
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                />
                                            </Stack>
                                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
                                                Ambos archivos se encontrarán comprimidos en un .zip
                                            </Typography>
                                        </Paper>
                                    </>
                                )
                            }

                            <Card>
                                {
                                    showForm && (
                                        <CardContent sx={{ p: 4 }}>
                                            <Stack spacing={3}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="empresa-label" size="small">
                                                        Empresa
                                                    </InputLabel>
                                                    <Select
                                                        size="small"
                                                        labelId="empresa-label"
                                                        value={ddjjParams.idEmpresa}
                                                        label="Empresa"
                                                        onChange={(e)=>setDdjjParams({...ddjjParams, idEmpresa:e.target.value})}
                                                        isOptionEqualToValue={(option, value) => option.idempresa === value.idempresa}
                                                    >
                                                        {empresas?.map((emp) => (
                                                            <MenuItem key={emp.idempresa} value={emp.idempresa}>
                                                                <Box>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {emp.empresa}
                                                                    </Typography>
                                                                </Box>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <Box>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="text.secondary"
                                                        gutterBottom
                                                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                                    >
                                                        <CalendarIcon fontSize="small" />
                                                        Período (Mes Calendario)
                                                    </Typography>
                                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                                        <FormControl sx={{ minWidth: 200 }} size="small">
                                                            <InputLabel id="mes-label">Mes</InputLabel>
                                                            <Select
                                                                labelId="mes-label"
                                                                value={ddjjParams.mes}
                                                                label="Mes"
                                                                onChange={(e) => setDdjjParams({ ...ddjjParams, mes: e.target.value })}
                                                            >
                                                                {periodos?.map((m) => (
                                                                    <MenuItem key={m.id} value={m.id} disabled={m.id > mesActual}>
                                                                        {m.mes}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>

                                                        <FormControl sx={{ minWidth: 150 }} size="small">
                                                            <InputLabel id="anio-label">Año</InputLabel>
                                                            <Select
                                                                labelId="anio-label"
                                                                value={ddjjParams.anio}
                                                                label="Año"
                                                                onChange={(e) => setDdjjParams({ ...ddjjParams, anio: e.target.value })}
                                                            >
                                                                {anios.map((anio) => (
                                                                    <MenuItem key={anio} value={anio}>
                                                                        {anio}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Stack>
                                                </Box>
                                                <Stack
                                                    direction={{ xs: "column", sm: "row" }}
                                                    spacing={2}
                                                    justifyContent="flex-end"
                                                >
                                                    <Button
                                                        variant="contained"
                                                        size="large"
                                                        startIcon={<DownloadIcon />}
                                                        onClick={handleGenerar}
                                                        disabled={generando || !ddjjParams.idEmpresa || !ddjjParams.mes || !ddjjParams.anio}
                                                        sx={{ minWidth: 200 }}
                                                    >
                                                        {generando ? "Generando..." : "Generar Archivos TXT"}
                                                    </Button>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    )
                                }
                            </Card>

                            {!showForm && userRes && (
                                <CardContent sx={{ p: 4 }}>
                                    <Stack spacing={3} alignItems="center">
                                        <Box
                                            sx={{
                                                width: 80,
                                                height: 80,
                                                borderRadius: "50%",
                                                bgcolor: "rgba(67, 160, 71, 0.1)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <CheckIcon sx={{ fontSize: 48, color: "secondary.main" }} />
                                        </Box>

                                        <Typography
                                            variant="h5"
                                            fontWeight={600}
                                            color="text.primary"
                                            textAlign="center"
                                        >
                                            Archivo generado exitosamente
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary" textAlign="center">
                                            La declaración jurada ha sido descargada correctamente
                                        </Typography>

                                        <Stack
                                            direction={{ xs: "column", sm: "row" }}
                                            spacing={2}
                                            sx={{ width: "100%", mt: 2 }}
                                        >
                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    flex: 1,
                                                    p: 3,
                                                    bgcolor: "#e8f5e9",
                                                    borderRadius: 3,
                                                    border: "1px solid #a5d6a7",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Typography
                                                    variant="overline"
                                                    color="text.secondary"
                                                    sx={{ letterSpacing: 1 }}
                                                >
                                                    Importe Total
                                                </Typography>
                                                <Typography
                                                    variant="h4"
                                                    fontWeight={700}
                                                    color="#2e7d32"
                                                    sx={{ mt: 1 }}
                                                >
                                                    ${userRes.importeTotal?.toLocaleString("es-AR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </Typography>
                                            </Paper>

                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    flex: 1,
                                                    p: 3,
                                                    bgcolor: "#e3f2fd",
                                                    borderRadius: 3,
                                                    border: "1px solid #90caf9",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Typography
                                                    variant="overline"
                                                    color="text.secondary"
                                                    sx={{ letterSpacing: 1 }}
                                                >
                                                    Cantidad de Registros
                                                </Typography>
                                                <Typography
                                                    variant="h4"
                                                    fontWeight={700}
                                                    color="primary.main"
                                                    sx={{ mt: 1 }}
                                                >
                                                    {userRes.cantReg}
                                                </Typography>
                                            </Paper>
                                        </Stack>
                                        <Box sx={{ mt: 3, textAlign: "center" }}>
                                            <Typography variant="body1" color="text.secondary" gutterBottom>
                                                ¿Desea generar otra declaración jurada?
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                size="large"
                                                onClick={() => {
                                                    setShowForm(true);
                                                    setUserRes(null);
                                                    handleLimpiar();
                                                }}
                                                sx={{ mt: 2, minWidth: 200 }}
                                            >
                                                Generar Nuevo Archivo
                                            </Button>
                                        </Box>
                                    </Stack>
                                </CardContent>
                            )}
                        </Box>
                    </Box>
                    {
                        <CustomBackdrop open={generando} text="Generando archivo..." />
                    }
                    {
                        notify?.open && (
                            <Notify
                                open={notify?.open}
                                mensaje={notify?.message}
                                severity={notify?.severity}
                                handleClose={() => {
                                    setNotify({ open: false, message: "", severity: "success" })
                                }}
                                duracion={notify.duracion}
                            />
                        )
                    }
                </ThemeProvider>

            </div>

        </div>
    )

}